export default {
  consultPage: {
    pageTitle: 'Contact us',
    railTitle: 'Inquiry Type',
    railDesc: 'Please leave your contact details and the scales you are interested in. We will have the appropriate specialist follow up based on your inquiry.',
    types: [
      { label: 'Product Inquiry', value: 'pre_sale' },
      { label: 'Project Collaboration', value: 'service_support' }
    ],
    name: 'Name',
    email: 'Email Address',
    company: 'Organization',
    phone: 'Phone',
    product: 'Scales of Interest',
    address: 'Address',
    message: 'Message',
    namePlaceholder: 'Enter your name',
    emailPlaceholder: 'Enter your email address',
    companyPlaceholder: 'Enter your organization',
    phonePlaceholder: 'Enter your phone number',
    productPlaceholder: 'Select a scale',
    addressPlaceholder: 'Enter your address',
    messagePlaceholder: 'Please enter your inquiry details',
    privacyPrefix: 'I have read and agree to the',
    privacyPolicy: 'Privacy Policy',
    privacySuffix: 'and consent to Huasheng Yulin using the above information for follow up on my inquiry.',
    submit: 'Submit Inquiry',
    submitting: 'Submitting...',
    success: 'Inquiry submitted',
    invalidEmail: 'Please enter a valid email address',
    required: 'Please complete all required inquiry information'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/locales/en/consult.js